import { CREATE_MACHINE, GET_MACHINE, MACHINE_REQUEST, DELETE_MACHINE, UPDATE_MACHINE, MACHINE_REQUEST_FAILURE } from "../types";

const initialState = {
  machines: [],
  loading: false,
  error: null,
};

const machineReducer = (state = initialState, action) => {
  switch (action.type) {
    case MACHINE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_MACHINE: {
      return {
        ...state,
        machines: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_MACHINE:
      return {
        ...state,
        machines: [action.payload, ...state.machines],
        loading: false,
        error: null
      };
    case UPDATE_MACHINE:
      const machinesData = state.machines.slice(0);
      const uIndex = machinesData.findIndex((data) => data.id === action.payload.id);
      machinesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        machines: [ ...machinesData ],
        loading: false,
        error: null
      };
    case DELETE_MACHINE:
      const machines = state.machines?.slice(0);
      const index = machines.findIndex((data) => data.id === action.id);
      if (index > -1) {
          machines.splice(index, 1);
      }
      return {
        ...state,
        machines: [...machines],
        loading: false,
        error: null
      }
    case MACHINE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default machineReducer;